import { render, staticRenderFns } from "./project-icon.vue?vue&type=template&id=795ca819&"
import script from "./project-icon.vue?vue&type=script&lang=js&"
export * from "./project-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports